function one (selector, el) {
  return el.querySelector(selector)
}

exports = module.exports = function (selector, el) {
  el = el || document
  return one(selector, el)
}

exports.all = function (selector, el) {
  el = el || document
  return el.querySelectorAll(selector)
}

exports.engine = function (obj) {
  if (!obj.one) throw new Error('.one callback required')
  if (!obj.all) throw new Error('.all callback required')
  // one = obj.one
  exports.all = obj.all
  return exports
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/range/range/lib/lib/query.js